import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import { COORDINATES_REGEX, formatCoordinates, parseCoordinates } from 'shared/utils/coordinates';
import styles from './coordinates-form.module.scss';
import type { ICoordinatesFormProps } from './types';

export const CoordinatesForm = (props: ICoordinatesFormProps) => {
  const { value, onChange } = props;
  const { t } = useTranslation('trip');

  const [inputValue, setInputValue] = useState<string>(formatCoordinates(value.lat, value.lng));
  const [error, setError] = useState<string>('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.trim();
    setInputValue(newValue);

    if (COORDINATES_REGEX.test(newValue)) {
      setError('');
      const parsed = parseCoordinates(newValue);
      onChange(parsed);
    } else {
      setError(t('coordinates_format_error'));
      onChange({ lat: undefined, lng: undefined });
    }
  };

  const getHelpText = () => {
    if (error) {
      return error;
    }
    if (value.lat !== undefined && value.lng !== undefined) {
      return t('coordinates_parsed', { lat: value.lat.toString(), lng: value.lng.toString() });
    }

    return undefined;
  };

  return (
    <div className={styles.container}>
      <Form.Item
        label={t('coordinates')}
        className={styles.input}
        validateStatus={error ? 'error' : ''}
        help={getHelpText()}>
        <Input placeholder={t('coordinates_placeholder')} value={inputValue} onChange={handleChange} />
      </Form.Item>
    </div>
  );
};
